import React, { useState } from 'react';
// eslint-disable-next-line import-x/no-extraneous-dependencies
import DOMPurify from 'dompurify';
import { componentTypes } from '@white-nl/instantsearch-components';
import Picture from '../../ui/Picture';
import { ArrowRight, ImageSlash } from '../../ui/icons/classic/regular';

export default function Hit({ hit, additionalData, results }: componentTypes.HitProps) {
  const {
    uri,
    title,
    image,
    imageLarge,
    customer,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    __position,
  } = hit;

  const firstHit = __position === 1;
  const firstHitBatch = __position % results.hitsPerPage === 1;
  const [TitleSize] = useState(additionalData.titleSize);

  return (
    <div
      className={`w-full md:px-2 lg:px-4${firstHitBatch ? '' : ' md:w-1/2'}`}
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem"
    >
      <meta itemProp="position" content={`${__position}`} />
      <a
        itemProp="item"
        itemScope
        itemType="https://schema.org/Thing"
        href={Craft.getSiteUrl(uri)}
        className="group/card block relative z-10 no-underline overflow-hidden rounded-lg focus-visible:outline-4 focus-visible:outline-orange"
      >
        <meta itemProp="name" content={`${Craft.t(additionalData.translates.projects, 'Case')} ${customer} ${title}`} />
        <meta itemProp="url" content={Craft.getSiteUrl(uri)} />
        {image ? (
          <Picture
            image={firstHitBatch ? imageLarge : image}
            loading={firstHit ? 'eager' : 'lazy'}
            defaultTransform="3xl-min"
            classes="absolute top-1/2 left-1/2 -translate-1/2 -z-20 w-full h-full object-cover group-hover/card:scale-105 group-focus/card:scale-105 transition-transform duration-1000"
            alt=""
          />
        ) : (
          <ImageSlash />
        )}
        <div
          className={`w-full flex flex-col justify-between gap-y-6 aspect-[5/4]${firstHitBatch ? ' md:aspect-video' : ''} after:absolute after:inset-0 after:-z-10 after:bg-linear-(--card-case) p-6 md:p-8 lg:p-10 text-white`}
        >
          <span
            className="text-base md:text-lg lg:text-xl font-bold leading-[1.4] tracking-[0.08em] uppercase"
          >
            {customer}
          </span>
          <div className="flex justify-between items-end gap-x-3 lg:gap-x-24 xl:gap-x-32">
            <TitleSize
              className="text-lg lg:text-3xl font-semibold leading-tight grow basis-0"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(title),
              }}
            />
            <ArrowRight
              iconClass="w-4 md:w-5 lg:w-5.5 mr-4 mb-2 md:mb-1 transition-all duration-500 group-hover/card:translate-x-4 group-focus/card:translate-x-4"
            />
          </div>
        </div>
      </a>
    </div>
  );
}
